import { QueryClientProvider } from '@tanstack/react-query';
import { lazy, PropsWithChildren, Suspense } from 'react';
import { queryClient } from '../api/query-client';
import AuthProvider from './AuthProvider';
import DevEnvironmentWarning from './DevEnvironmentWarning';
import NotificationProvider from '../components/ui/notifications/NotificationProvider';
import { ThemeProvider } from './ThemeProvider';
import MarketingAttributionProvider from './MarketingAttributionProvider';

const shouldEnableQueryDevtools = import.meta.env.DEV || import.meta.env.VITE_ENABLE_QUERY_DEVTOOLS === 'true';

const ReactQueryDevtools = shouldEnableQueryDevtools
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((module) => ({
        default: module.ReactQueryDevtools,
      })),
    )
  : null;

const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <MarketingAttributionProvider>
          <AuthProvider>
            <NotificationProvider>
              {children}
              <DevEnvironmentWarning />
              {ReactQueryDevtools ? (
                <Suspense fallback={null}>
                  <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" position="bottom" />
                </Suspense>
              ) : null}
            </NotificationProvider>
          </AuthProvider>
        </MarketingAttributionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default AppProviders;
